import {fetchWithTimeout, checkPermission, TIMEOUT, PERMISSION_ADMIN, PERMISSION_OPERATOR, PERMISSION_MONITORING} from './api_common';
import {getCookie, showToast, getFetchError, getCatchError} from '../app_common.js';

export const getApiReceiveEdge = async(pagePer, pageCur, status, product, sortTitle, sortOrder) => {
    if( !checkPermission('getApiReceiveEdge', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/receive-edge?per_page=${pagePer}&page=${pageCur}&status=${status}${product.length>0?'&product='+product:''}${sortTitle.length>0?'&sort_title='+sortTitle:''}${sortOrder.length>0?'&sort_order='+sortOrder:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiReceiveEdgeId = async(edgeId) => {
    if( !checkPermission('getApiReceiveEdgeId', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/receive-edge/${edgeId}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const putApiReceiveEdgeIdStatus = async(edgeId, status) => {
    if( !checkPermission('putApiReceiveEdgeIdStatus', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/receive-edge/${edgeId}/status?status=${status}`, {
            timeout: TIMEOUT,
            method: 'PUT',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const putApiReceiveEdgeIdConfig = async(edgeId, postData) => {
    if( !checkPermission('putApiReceiveEdgeIdConfig', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/receive-edge/${edgeId}/config`, {
            timeout: TIMEOUT,
            method: 'PUT',
            headers: {
                "accept": "application/json",
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(postData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiReceiveEdgeCount = async(status, product) => {
    if( !checkPermission('getApiReceiveEdgeCount', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/receive-edge-count?status=${status}${product.length>0?'&product='+product:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiReceiveEdgeDataQuery = async(receiveId) => {
    if( !checkPermission('getApiReceiveEdgeDataQuery', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/receive-edge-data/query${receiveId.length>0?'?id='+receiveId:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiReceiveEdgeDataQueryRange = async(id, product, start, end) => {
    if( !checkPermission('getApiReceiveEdgeDataQueryRange', PERMISSION_MONITORING) )
    { 
        return null;
    }

    let productQuery = '';
    if( product.length > 0 )
    {
        if( id.length > 0 )
        {
            productQuery = `${'&product='+product}`;
        }
        else
        {
            productQuery = `${'?product='+product}`;
        }
    }

    let startQuery = '';
    if( start.length > 0 )
    {
        if( id.length > 0 || product.length > 0 )
        {
            startQuery = `${'&start='+start}`;
        }
        else
        {
            startQuery = `${'?start='+start}`;
        }
    }

    let endQuery = '';
    if( end.length > 0 )
    {
        if( id.length > 0 || product.length > 0 || start.length > 0)
        {
            endQuery = `${'&end='+end}`;
        }
        else
        {
            endQuery = `${'?end='+end}`;
        }
    }

    try {
        const response = await fetchWithTimeout(`/api/receive-edge-data/query/range${id.length>0?'?id='+id:''}${productQuery}${startQuery}${endQuery}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

//추후 정리될 API, 아직 사용못함
export const getApiReceiveEdgeSummary = async(status) => {
    if( !checkPermission('getApiReceiveEdgeSummary', PERMISSION_MONITORING) )
    { 
        return null;
    }
}

export const getApiReceiveEdgeKeyword = async() => {
    if( !checkPermission('getApiReceiveEdgeKeyword', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/receive-edge-keyword`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}